import PropTypes from 'prop-types';
import React from 'react';

import Image from 'components/ImageV2';
import { Medium, LargeUp } from 'components/MediaQuery';
import { IMAGE_WIDTHS } from 'constants/images';

import Caption from './Caption';
import { DIMENSIONS } from './constants';
import Placeholder from './Placeholder';

export { DIMENSIONS };

const CollectionLifestyleCard = ({ imageUrl, captionText, isLoading }) =>
  isLoading ? (
    <Placeholder />
  ) : (
    <div className="CollectionLifestyleCard">
      <Medium>
        <Image
          alt={captionText}
          src={imageUrl}
          transformations={{
            crop: 'fill',
            aspectRatio: DIMENSIONS.TABLET_WIDTH / DIMENSIONS.TABLET_HEIGHT,
          }}
          width={IMAGE_WIDTHS.W_1000}
          ratio={`${DIMENSIONS.TABLET_WIDTH}:${DIMENSIONS.TABLET_HEIGHT}`}
          className="CollectionLifestyleCard__image"
        />
        <Caption text={captionText} />
      </Medium>
      <LargeUp>
        <Image
          src={imageUrl}
          alt={captionText}
          transformations={{
            crop: 'fill',
            aspectRatio: DIMENSIONS.DESKTOP_WIDTH / DIMENSIONS.DESKTOP_HEIGHT,
          }}
          width={IMAGE_WIDTHS.W_1000}
          ratio={`${DIMENSIONS.DESKTOP_WIDTH}:${DIMENSIONS.DESKTOP_HEIGHT}`}
          className="CollectionLifestyleCard__image"
        />
        <Caption text={captionText} />
      </LargeUp>
      <style jsx>
        {`
          .CollectionLifestyleCard {
            width: 100%;
            position: relative;
          }
        `}
      </style>
      <style jsx global>
        {`
          .CollectionLifestyleCard__image {
            width: 100%;
          }
        `}
      </style>
    </div>
  );

CollectionLifestyleCard.propTypes = {
  imageUrl: PropTypes.string.isRequired,
  captionText: PropTypes.string.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export default CollectionLifestyleCard;
